import React from 'react';
import { FlexDiv } from './design-system/containers';
import { palette } from './design-system/colors';

/**
 * A simple element that is split into two halves, with the left half being white and the right half being light gray.
 * @param leftHalf
 * @param rightHalf
 * @param stackOnMobile - if true, the left half will be stacked on top of the right half on mobile
 * @returns {JSX.Element}
 * @constructor
 */
export function FiftyFiftyDiv({ leftHalf, rightHalf, stackOnMobile }) {
    return (
        <FlexDiv flexGrow={2} stackOnMobile={stackOnMobile}>
            <FlexDiv
                flexGrow={1}
                padding={50}
                backgroundColor={palette.graphite.white}
            >
                {leftHalf}
            </FlexDiv>
            <FlexDiv
                flexGrow={1}
                padding={50}
                backgroundColor={palette.graphite.cloud}
            >
                {rightHalf}
            </FlexDiv>
        </FlexDiv>
    );
}
